import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import GuestUpdateChild from "./GuestUpdateChild";

import { useLocation } from "react-router-dom";

const GuestUpdate = () => {
  const data = useLocation();
  const guestRecord = data.state;

  return (
    <MainTemplate>
      <CardBackground>
        <GuestUpdateChild guestRecord={guestRecord} />
      </CardBackground>
    </MainTemplate>
  );
};

export default GuestUpdate;
